import { LoginService } from './../login.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivityHoursComponent } from '../activity-hours/activity-hours.component';
import { RoomsActivityHoursComponent } from '../rooms-activity-hours/rooms-activity-hours.component';
import { ExamsNamesComponent } from '../exams-names/exams-names.component';
import { QuestionnaireTemplatesComponent } from '../questionnaire-templates/questionnaire-templates.component';



@Component({
    selector: 'app-user-settings',
    templateUrl: './user-settings.component.html',
    styleUrls: ['./user-settings.component.scss'],
    standalone: false
})
export class UserSettingsComponent implements OnInit {
  @ViewChild(ActivityHoursComponent) ActivityHoursComponent: ActivityHoursComponent;
  @ViewChild(RoomsActivityHoursComponent) RoomsActivityHoursComponent: RoomsActivityHoursComponent;
  @ViewChild(ExamsNamesComponent) ExamsNamesComponent: ExamsNamesComponent;
  @ViewChild(QuestionnaireTemplatesComponent) QuestionnaireTemplatesComponent: QuestionnaireTemplatesComponent;

  page='exams'
  appointmentsByRooms=false
  showAlertBeforeExit=false
  constructor(private router:Router,public ls: LoginService, private http: HttpClient) {
    this.ls.loginMissing()
  }

  ngOnInit(): void {
 this.appointmentsByRooms=this.ls?.premissions?.ApptsByRoom
 this.appointmentsByRooms? this.initFirstRoom():this.initFirstDoctor();

 // Deep-link entry (/questionnaires or /questionnaires/:code) lands directly on the tab.
 if (this.router.url.includes('/questionnaires')) {
   this.page = 'questionnaires';
 }
 if (this.router.url.includes('/financial')) {
   this.page = 'Financial Report';
 }
  }


  exit(){
    if (this.page=='Activity Hours' && this.ActivityHoursComponent.hasUnsavedChanges) {
    this.showAlertBeforeExit=true
    return
    }
    if (this.page=='rooms Activity Hours' && this.RoomsActivityHoursComponent.hasUnsavedChanges) {
      this.showAlertBeforeExit=true
      return
      }
      if (this.page=='exams' && this.ExamsNamesComponent.checkIfAnyExamEditing()) {
        this.showAlertBeforeExit=true
        return
      }
      if (this.page=='questionnaires' && this.QuestionnaireTemplatesComponent?.checkIfEditing()) {
        this.showAlertBeforeExit=true
        return
      }
    this.leave();
  }


  goToCalendar(){
    this.leave();
  }

  // Leave settings to wherever the user belongs: appointments/billing if they
  // have those permissions, otherwise back to the clinical system (questionnaire-only user).
  private leave(){
    if (this.ls.premissions?.Appointments) {
      this.router.navigate(["/appointments"]);
    } else if (this.ls.premissions?.Billings) {
      this.router.navigate(["/billing"]);
    } else {
      this.redirectAdministration();
    }
  }

  // Seamless jump back to the clinical system (mirrors BarComponent.redirectAdministration).
  redirectAdministration(){
    const type = this.ls.isCardio ? 'cardio' : this.ls.isGastro ? 'gastro' : this.ls.isEyes ? 'eyes' : this.ls.isUSG ? 'usg' : 'aweb';
    this.http.post('/api/administration', { type }).subscribe((data: string) => {
      window.location.href = data;
    });
  }



  goToBilling(){
    this.router.navigate(["/billing"]);
  }

  setPage(page){
  this.page=page
  }

  initFirstDoctor(){
    if(Array.isArray(this.ls.clinicUsers) && !this.ls.doctor && this.ls.clinicUsers.length){
      this.ls.doctor=this.ls.clinicUsers[0]['UID']

    }
  }
  initFirstRoom(){
    if(Array.isArray(this.ls.rooms) && (!this.ls.room|| this.ls.room=='No Room') && this.ls.rooms.length){
      this.ls.room=this.ls.rooms[0]['AutoIndex']

    }
  }

 async saveAndExit() {
    if (this.ActivityHoursComponent) {
      this.ActivityHoursComponent.saveActivityHours();  
    }
    if (this.RoomsActivityHoursComponent) {
      this.RoomsActivityHoursComponent.saveActivityHours();  
    }
    if (this.ExamsNamesComponent) {
    await  this.ExamsNamesComponent.saveAll();  
    }

    this.goToCalendar();
  }

}
